// This file was automatically generated from print.paymentCharge.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.paymentCharge');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.paymentCharge.practiceFacingContent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  el8.template.print.header(opt_data, output);
  el8.template.print.paymentCharge._title(opt_data, output);
  el8.template.print.paymentCharge._paymentTo(opt_data, output);
  el8.template.print.paymentCharge._paymentNotes(opt_data, output);
  el8.template.print.paymentCharge._lineItems(opt_data, output);
  el8.template.print.paymentCharge._summary(opt_data, output);
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.paymentCharge._title = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><div class="el8AlignRight"><h3 class="mt20 mb10 el8Bold">', (opt_data.paymentCharge.status == 'refunded') ? 'Refund confirmation' : 'Receipt', '</h3><p>Date created: ', (soy.$$escapeHtml(opt_data.paymentCharge.createdAt)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.paymentCharge.createdAt)) : ''), '</p><p>Payment method: ', (opt_data.paymentCharge.paymentType == 'card') ? (opt_data.paymentCharge.anticipatedPaymentMethodDescription) ? soy.$$escapeHtml(opt_data.paymentCharge.anticipatedPaymentMethodDescription) : (opt_data.paymentCharge.paymentMethodDescription) ? soy.$$escapeHtml(opt_data.paymentCharge.paymentMethodDescription) : soy.$$escapeHtml(opt_data.paymentCharge.paymentTypeDisplay) : soy.$$escapeHtml(opt_data.paymentCharge.paymentTypeDisplay), '</p></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.paymentCharge._paymentTo = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><h4 class="mb10 el8Bold">', (opt_data.paymentCharge.status == 'refunded') ? 'Refunded to' : 'Paid', '</h4><p style="font-size: 13px;">', soy.$$escapeHtml(opt_data.patientDetails.name), '</p><p style="font-size: 13px;">', soy.$$escapeHtml(opt_data.patientDetails.contactDestination), '</p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.paymentCharge._paymentNotes = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.patientLiability.externalMemo) ? '<div><h4 class="mb10 el8Bold">Note</h4><p style="overflow-wrap: break-word">' + soy.$$escapeHtml(opt_data.patientLiability.externalMemo) + '</p></div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.paymentCharge._lineItems = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><table cellpadding="0" cellspacing="0" class="w100 el8PaymentCharge mt30"><tr><td class="el8Bold">Reason</td><td class="w20"></td><td class="el8Bold w20 el8AlignCenter">Charge</td></tr><tr style="background: #E0E8EA;"><td>');
  var reasonList16271 = opt_data.patientLiability.reasonsDisplay;
  var reasonListLen16271 = reasonList16271.length;
  for (var reasonIndex16271 = 0; reasonIndex16271 < reasonListLen16271; reasonIndex16271++) {
    var reasonData16271 = reasonList16271[reasonIndex16271];
    output.append(soy.$$escapeHtml(reasonData16271), (! (reasonIndex16271 == reasonListLen16271 - 1)) ? ', ' : '');
  }
  output.append('</td><td></td><td class="el8AlignCenter">', (soy.$$escapeHtml(opt_data.paymentCharge.amountUsd)? el8.util.string.formatMoney(soy.$$escapeHtml(opt_data.paymentCharge.amountUsd)) : ''), '</td></tr></table><table cellpadding="0" cellspacing="0" class="w40 el8PaymentCharge" style="margin: 0 0 0 auto"><tr class="el8LedgerLine"><td class="el8AlignCenter w50"><p class="pt5">Subtotal</p></td><td class="el8AlignCenter w50">', (soy.$$escapeHtml(opt_data.paymentCharge.amountUsd)? el8.util.string.formatMoney(soy.$$escapeHtml(opt_data.paymentCharge.amountUsd)) : ''), '</td></tr><tr class="el8LedgerLine" style="background: #E0E8EA;"><td class="el8AlignCenter w50"><p class="pt5">Charge amount</p></td><td class="el8AlignCenter w50">', (soy.$$escapeHtml(opt_data.paymentCharge.amountUsd)? el8.util.string.formatMoney(soy.$$escapeHtml(opt_data.paymentCharge.amountUsd)) : ''), '</td></tr></table></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.paymentCharge._summary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8AlignRight" style="font-size: 16px; padding-top: 16px;">', (opt_data.paymentCharge.status == 'pending') ? (soy.$$escapeHtml(opt_data.paymentCharge.amountUsd)? el8.util.string.formatMoney(soy.$$escapeHtml(opt_data.paymentCharge.amountUsd)) : '') + ' will be charged ' + ((opt_data.paymentCharge.anticipatedNumHoursToCompletion) ? 'within ' + soy.$$escapeHtml(opt_data.paymentCharge.anticipatedNumHoursToCompletion) + ' hours' : ' soon') : (opt_data.paymentCharge.status == 'refunded') ? (soy.$$escapeHtml(opt_data.paymentCharge.amountUsd)? el8.util.string.formatMoney(soy.$$escapeHtml(opt_data.paymentCharge.amountUsd)) : '') + ' ' + soy.$$escapeHtml(opt_data.paymentCharge.statusDisplay) + ' on ' + (soy.$$escapeHtml(opt_data.paymentCharge.refundedAt)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.paymentCharge.refundedAt)) : '') : (soy.$$escapeHtml(opt_data.paymentCharge.amountUsd)? el8.util.string.formatMoney(soy.$$escapeHtml(opt_data.paymentCharge.amountUsd)) : '') + ' ' + soy.$$escapeHtml(opt_data.paymentCharge.statusDisplay) + ((opt_data.paymentCharge.completedAt) ? ' on ' + (soy.$$escapeHtml(opt_data.paymentCharge.completedAt)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.paymentCharge.completedAt)) : '') : ''), '</div>');
  if (!opt_sb) return output.toString();
};
